import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '@services/notification.service';
import { UsersService } from '../../services/users.service';
import { userEditUuid } from '../user-landing/user-landing.component';
import { UserService } from '@services/user.service';
import { WebErrorService } from '@services/webError.service';
import { ItemService } from '@services/item.service';
import { AccountAdminRole } from '@configs/role.config';
import { customValidationService } from 'src/app/shared/custom.validator';
@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss'],
})
export class UserEditComponent implements OnInit {
  userDetailsForm: FormGroup;
  duplicateDataFlag = false;
  action = 'createUser';
  useruuid: number;
  isAddMode: boolean;
  userData: any;
  oldEmail;
  selectedRoleData: any[] = [];
  collectionWithRoles: any[] = [];
  allRoles: any;
  oldUserId: any;
  oldEmailId: any;
  isEmailNotValid: boolean = false;
  statusList: any;
  inValidPhone: boolean = false;
  accountAdmin = AccountAdminRole.accountAdmin;
  assignedRole: any;
  constructor(
    private usersService: UsersService,
    private router: Router,
    private actRoute: ActivatedRoute,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<UserEditComponent>, @Inject(MAT_DIALOG_DATA)
    public userUuidData: userEditUuid,
    public fb: FormBuilder,
    private usersServ: UserService,
    public itemService: ItemService
  ) {
    this.assignedRole = JSON.parse(sessionStorage.getItem('currentUser') || '{}').userRolesCollections[0].rolesAssigned;
  }

  ngOnInit(): void {
    this.usersService.getStatusList().subscribe((statusList) => { this.statusList = statusList.data;})
    this.useruuid = this.userUuidData.useruuid;
    // this.useruuid = this.actRoute.snapshot.params['id'];
    this.isAddMode = !this.useruuid;

    this.userDetailsForm = this.fb.group({
      firstName: ['', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        Validators.pattern(/^[ a-zA-Z.-]+([a-zA-Z.-. ])*$/),
      ]],
      lastName: ['', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        Validators.pattern(/^[ a-zA-Z.-]+([a-zA-Z.-. ])*$/),
      ]],
      phone: ['', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(24),
        Validators.pattern(/^(?:\+?(\d{0,3}))?[- \(]*(\d{1,9})[-. \/)]*(\d{1,9})[-. \/]*(\d{1,9})*[-. \/]*(\d{1,9})(?: *x(\d))?$/
        ),
      ]],
      emailId: [null, [
        Validators.required,
        Validators.minLength(7),
        Validators.pattern(
          /^[a-zA-Z0-9]+([.]?[_]?[a-zA-Z0-9])*@[a-zA-Z0-9]+([\-\.]?[a-zA-Z0-9]+)*\.[A-Za-z]{1,3}$/
        ),
      ]],
      roles: new FormArray([]),
      status: [{ value: 'true' }, [Validators.required]],
      'speciality': new FormControl(null,
        [Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100),
        customValidationService.cannotContainSpace,
        Validators.pattern(/^[a-z\d\-_\s]+$/i)
        // Validators.pattern(/^[a-zA-Z0-9]+$/)
        ]),
        'center': new FormControl(null,
        [Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100),
        customValidationService.cannotContainSpace,
        Validators.pattern(/^[a-z\d\-_\s]+$/i)
        ]),
    });

    this.usersServ.getRoles().subscribe((data) => {
      this.allRoles = data.data;

      this.usersService.getUsersByID(this.useruuid)?.subscribe((resData) => {
        this.userData = resData?.data;
        this.oldEmailId = this.userData.emailId;
        this.getEmailDetails();
        this.userDetailsForm.controls['firstName'].setValue(
          this.userData.firstName.trim()
        );
        this.userDetailsForm.controls['lastName'].setValue(
          this.userData.lastName.trim()
        );
        this.userDetailsForm.controls['phone'].setValue(this.userData.phone);
        this.userDetailsForm.controls['emailId'].setValue(this.userData.emailId.trim());
        this.userDetailsForm.controls['speciality'].setValue(this.userData.speciality);
        this.userDetailsForm.controls['center'].setValue(this.userData.center);
        this.oldEmail = this.userData.emailId.trim();
        this.userDetailsForm.controls['status'].setValue(this.userData.active);
        if (this.userData.collectionWithRoles && this.userData.collectionWithRoles.length) {
          this.collectionWithRoles = this.userData.collectionWithRoles;
          this.userData.collectionWithRoles.forEach((element, i) => {
            const collectionUser = this.userDetailsForm.controls.roles as FormArray;
            collectionUser.push(new FormGroup({
              collectionname: new FormControl(element.collectionname),
              collectionid: new FormControl(element.collectionid),
              roleid: new FormArray([])
            }));

            this.allRoles.forEach(r => {
              this.userDetailsForm.controls.roles['controls'][i]['controls'].roleid.push(new FormGroup({
                roleid: new FormControl(r.roleId),
                rolename: new FormControl(r.role),
                selected: new FormControl(false)
              }));
            });

            this.userDetailsForm.controls.roles['controls'][i]['controls'].roleid.value.forEach((role, index) => {
              if(element.roles.length>0) {
                element.roles.forEach(e => {
                  if (e.roleid == role.roleid) {
                    this.userDetailsForm.controls.roles['controls'][i]['controls'].roleid['controls'][index]['controls'].selected.setValue(true);
                  }
                });
              }
            });

            // element.roles.forEach(e => {
            //   this.userDetailsForm.controls.roles['controls'][i]['controls'].roleid.push(new FormGroup({
            //     roleid: new FormControl(e.roleid),
            //     rolename: new FormControl(e.rolename),
            //     selected: new FormControl(e.roleid ? true : false)
            //   }));
            // });
          });
        };
      },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });

  }

  onClickOutside(event: any) {
    if(event) {
      this.inValidPhone = true;
    } else {
      this.inValidPhone = false;
    }
  }

  getEmailDetails() {
    this.userDetailsForm.controls.emailId.valueChanges.subscribe(data => {
      if (this.oldEmailId !== data) {
        this.isEmailNotValid = true;
        this.notificationService.warn('Cannot change Email');
      } else {
        this.isEmailNotValid = false;
      }
    })
  }

  shouldDisable() {
    var count = 0;
    for (let r of this.userDetailsForm.controls['roles'].value) {
      var countSelected = 0;
      if (r.roleid.length !== 0) {
        for (let roleId of r.roleid) {
          if (roleId.length !== 0) {
            if (roleId.selected) countSelected++;
          }
        }
        if (countSelected !== 0) count++
      }
    }
    return count !== this.userDetailsForm.controls['roles'].value.length;
  }

  get f() {
    return this.userDetailsForm.controls;
  }

  changeField(event: KeyboardEvent) {
    // this.webErrorService.customErrors('Cannot change Email', true, 'warn')
    if (event.key === ' ' && !this.userDetailsForm.value.emailId.length)
      event.preventDefault();
  }

  updateUserDetails() {
    if (this.userDetailsForm.invalid) {
      return;
    }
    this.selectedRoleData = [];
    this.userDetailsForm.controls.roles.value.filter(e => e.roleid.find(d => d.selected === true)).forEach((ele) => {
      const obj = { collectionid: ele.collectionid, roleid: [] };
      ele.roleid.filter(d => d.selected == true).forEach(x => obj.roleid.push(x.roleid));
      this.selectedRoleData.push(obj);
    })

    const apiData = {
      firstName: this.userDetailsForm.value.firstName,
      lastName: this.userDetailsForm.value.lastName,
      phone: this.userDetailsForm.value.phone == '' ? null : this.userDetailsForm.value.phone,
      active: this.userDetailsForm.value.status,
      userrole: this.selectedRoleData,
      speciality: this.userDetailsForm.value.speciality,
      center: this.userDetailsForm.value.center,
    };
    this.usersService.editUser(apiData, this.useruuid).subscribe(
      (resData) => {
        this.usersService.getusersLanding()?.subscribe(resData => {
          this.usersService.newUserList(resData);
        },
        (error: any) => {
          this.webErrorService.handleAPIErrors(error);
        });
        this.notificationService.success(resData?.message);
        this.router.navigate(['/users']);
        this.dialogRef.close();
        if (resData.useruuid) {
          // this.router.navigate(["/users", data.testId]);
          // alert("User updated successfully");
        }
      },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      });
  }

  onTestNameControlFocus(): void {
    this.duplicateDataFlag = false;
  }

  navigateToUsersLanding() {
    this.router.navigate(['/users']);
  }
  onKeydown(event: KeyboardEvent) {
    if (event.key === ' ' && !this.userDetailsForm.value.phone.length)
      event.preventDefault();
  }
}
